import { useEffect } from "react";
import { useShallow } from "zustand/react/shallow";

import { Echo } from "@/lib/echo";
import { useTenant } from "@/user/services/tenant";

import { useMessengerContext } from "../store";

type User = {
  id: number;
};

export function useGetOnlineUsers() {
  const tenant = useTenant();

  const { setOnlineUsers, addOnlineUser, removeOnlineUser } =
    useMessengerContext(
      useShallow(({ setOnlineUsers, addOnlineUser, removeOnlineUser }) => ({
        setOnlineUsers,
        addOnlineUser,
        removeOnlineUser,
      })),
    );

  useEffect(() => {
    Echo.join(`${tenant.id}.messenger.chat`)
      .here((users: User[]) => {
        setOnlineUsers(users);
      })
      .joining((user: User) => {
        addOnlineUser(user);
      })
      .leaving((user: User) => {
        removeOnlineUser(user);
      });

    return () => {
      Echo.leave(`messenger.chat`);
    };
  }, [tenant.id, setOnlineUsers, addOnlineUser, removeOnlineUser]);
}
